import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/modal/Modal";
import StatusCard from "../../components/status-card/StatusCard";
import AddBank from "./AddBank";
import { fetchAllbanks } from "../../redux/features/bank.features";
import Table from "../../components/table/Table";

const BanksManagement = () => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(fetchAllbanks());
  }, [dispatch]);

  let bankState = useSelector((state) => {
    return state.bankReducer;
  });
  let { banks, loading, editbank, bankUpdated } = bankState;

  useEffect(() => {
    if (!showModal) setTab(null);
  }, [showModal]);

  
  
const bankTableHead = [
    "Id",
    "bankName",
    "bankCode",
    "accountName",
    "accountNo",
    "swiftCode",
    "bankAddress",
    "routingNo",
    "country",     
    "status",
  ];
  
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  const renderBody = (item, index) => {
   // let selectedCustomerStore =  props.selectedCustomer
    return (
    <tr  key={index}>
      <td>{item.bankId}</td>
      <td>{item.bankName}</td>
      <td>{item.bankCode}</td>
      <td>{item.accountName}</td>
      <td>{item.accountNo}</td>
      <td>{item.swiftCode}</td>
      <td>{item.bankAddress}</td>
      <td>{item.routingNo}</td>
      <td>{item.country}</td>
      <td>{item.status}</td>
    </tr>
  );
  }



  return (
    <div>
      <h2 className="my-3 flex items-center text-white text-3xl font-extrabold">
        <i className="bx bxs-bank mx-2"></i>
        Banks Management
      </h2>

      <div className="flex my-4">
        {" "}
        <div className="col-3">
          <StatusCard
            icon={"bx bxs-bank"}
            count={banks.length}
            title={"Banks"}
          ></StatusCard>
        </div>
      </div>
      <hr></hr>
      <div className="flex my-4">
        <div className="flex w-full my-3 ">
          <button
            onClick={() => {
              setTab(0);
              setShowModal((state) => !state);
            }}
            className="w-4/12 uppercase   m-2 rounded p-4 text-white bg-green-500 hover:bg-green-700 flex justify-between items-center"
            style={{
              backgroundColor: tab === 0 ? "var(--bg-dark)" : "",
              border: tab === 0 ? "2px solid white" : "none",
            }}
          >
            <span className="text-white font-extrabold bx bxs-bank text-4xl"></span>{" "}
            Add New Bank
          </button>

          <button
            onClick={() => {
              setTab(1);
            }}
            className="w-4/12 uppercase   m-2 rounded p-4 text-white bg-green-500 hover:bg-green-700 flex justify-between items-center"
            style={{
              backgroundColor: tab === 1 ? "var(--bg-dark)" : "",
              border: tab === 1 ? "2px solid white" : "none",
            }}
          >
            <span className="text-white font-extrabold bx bx-printer text-4xl"></span>{" "}
            PRINT ALL BANKS
          </button>
        </div>
      </div>
      <div className="flex my-4">
      {
                  loading && (<h1>Loading please wait...</h1>)
                }
                {
                 !loading && banks && banks.length !==0   ?(
                    <div> 
                    <Table
                    tableHeaderStyle={{style : { backgroundColor:'var(--main-bg)', color:'white', fontWeight:'900'}}}
                    limit="5"
                    headData={bankTableHead}
                    renderHead={(item, index) => renderHead(item, index)}
                    bodyData={banks}
                    renderBody={(item, index) => renderBody(item, index)}
                  />
                   
                   </div>
                  ):null
                }
      </div>

      <Modal
        modal_title={"Create New Bank"}
        canShow={showModal}
        updateModalState={() => setShowModal((state) => !state)}
      >
        <div>
          <AddBank onClose={() => setShowModal((state) => !state)} />
        </div>
      </Modal>
    </div>
  );
};

export default BanksManagement;
